import { render, staticRenderFns } from "./BlocoResumoContratoOriginacao.vue?vue&type=template&id=8cf7aca6&lang=pug"
import script from "./BlocoResumoContratoOriginacao.vue?vue&type=script&lang=js"
export * from "./BlocoResumoContratoOriginacao.vue?vue&type=script&lang=js"
import style0 from "./BlocoResumoContratoOriginacao.vue?vue&type=style&index=0&id=8cf7aca6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports